import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { ArrowDown } from '@ringcentral/juno-icon';
import { styled } from '../../../../foundation';
import { RcIcon } from '../../../Icon';
var _SelectArrowDownIcon = forwardRef(function (_a, ref) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement(RcIcon, __assign({ ref: ref, className: clsx('MuiSvgIcon-root', className), 
        // TODO: remove when VirtualizeBoxSelect, and VirtualizedLineSelect remove
        color: "neutral.f04", size: "large", symbol: ArrowDown }, rest)));
});
export var SelectArrowDownIcon = styled(_SelectArrowDownIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
